/* Geometry and rules of the uncover game, kept apart from the canvas so they can be tested. */

/* Triangles tiling a w × h area, same layout as Mosaic: alternating up/down, rows of height size·0.866. */
export function buildTiles(w, h, size) {
  const th = size * 0.866;
  const rows = Math.ceil(h / th) + 1;
  const cols = Math.ceil(w / (size / 2)) + 2;
  const tiles = [];
  for (let y = 0; y < rows; y++) {
    for (let x = -1; x < cols; x++) {
      const up = (x + y) % 2 === 0;
      const x0 = (x * size) / 2;
      const y0 = y * th;
      const pts = up
        ? [x0, y0 + th, x0 + size / 2, y0, x0 + size, y0 + th]
        : [x0, y0, x0 + size, y0, x0 + size / 2, y0 + th];
      tiles.push({ pts, cx: x0 + size / 2, cy: up ? y0 + (2 * th) / 3 : y0 + th / 3, x, y });
    }
  }
  return tiles;
}

/* Indices of the tiles whose centre lies within r of (px, py). */
export function tilesNear(tiles, px, py, r) {
  const out = [];
  const r2 = r * r;
  for (let i = 0; i < tiles.length; i++) {
    const dx = tiles[i].cx - px;
    const dy = tiles[i].cy - py;
    if (dx * dx + dy * dy <= r2) out.push(i);
  }
  return out;
}

/* Whole-number percent of tiles found; 100 only when every tile is. */
export function percentFound(found, total) {
  if (!total) return 0;
  const p = Math.floor((found / total) * 100);
  return found >= total ? 100 : Math.min(p, 99);
}
